// extracted by mini-css-extract-plugin
export default {"reactPlayer":"Template3_reactPlayer__FKopr","tagLine":"Template3_tagLine__63unP","button":"Template3_button__z8KLk"};